export default "__VITE_ASSET__fab1e42e__"